module.exports = __webpack_public_path__ + "static/empty-states-cta-do-ea1324d0d06a1e76c99611a3b4fe9178.png";